import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sendTrackingInfo } from '@panel/commons';
import { crmFinishReasonsIds } from '@panel/commons/helpers/CRMOptionsConfig';
import { select } from '@panel/commons/core/themev2';
import AlquiladoIcon from '../../../../assets/icons/AlquiladoIcon.svg';
import DuplicadoIcon from '../../../../assets/icons/DuplicadoIcon.svg';
import FraudeIcon from '../../../../assets/icons/FraudeIcon.svg';
import NoEspecificadoIcon from '../../../../assets/icons/NoEspecificadoIcon.svg';
import CanceladoIcon from '../../../../assets/icons/CanceladoIcon.svg';
import shuffle from '../../../../assets/icons/shuffle.svg';

const FinishReasonInfo = ({ isDeleted, finishReasonByPosting, publisherTypeId, lockedSoft, openModal, postingId }) => {
  const { t } = useTranslation();
  const isProfessional = publisherTypeId !== '1';
  const publisherType = isProfessional ? 'profesional' : 'particular';
  const showButtonCTA =
    (!isDeleted && finishReasonByPosting && finishReasonByPosting.reason) ||
    (isDeleted && finishReasonByPosting && finishReasonByPosting.reason === 'leave_credit');

  const getFinishReasonIcon = finishReason => {
    if (!finishReason || finishReason.reason === 'other') return null;
    const finishReasonIcon = {
      fraud: FraudeIcon,
      infringement: FraudeIcon,
      duplicate: DuplicadoIcon,
      operation_cancelled: CanceladoIcon,
      sell_rent: AlquiladoIcon,
      leave_credit: shuffle
    };

    return finishReason.reason ? finishReasonIcon[finishReason.reason] : NoEspecificadoIcon;
  };

  const getTextReason = finishReason => {
    if (finishReason && finishReason.reason === 'other') return finishReason.description;
    if (finishReason && finishReason.reason) {
      return t(
        crmFinishReasonsIds.includes(finishReason.reason)
          ? `panel.avisos.finishReason.motivo.${finishReason.reason}`
          : `panel.avisos.finishReason.motivo.${publisherType}.${finishReason.reason}`
      );
    }
    return t('panel.avisos.finishReason.motivo.without_data');
  };

  return (
    <Container data-panel={`panel-finishReason-container-${postingId}`}>
      <Title data-panel={`panel-finishReason-title-${postingId}`}>{t('panel.avisos.finishReason.title')}</Title>
      <TextReason data-panel={`panel-finishReason-text-${postingId}`}>
        {getFinishReasonIcon(finishReasonByPosting) ? (
          <img src={getFinishReasonIcon(finishReasonByPosting)} alt='Icono motivo' />
        ) : null}
        {getTextReason(finishReasonByPosting)}
      </TextReason>
      {showButtonCTA ? (
        <ButtonCTA
          data-panel={`panel-finishReasonByPosting-cta-${postingId}`}
          onClick={e => {
            // Se implementa la misma funcionalidad de los botones de Republicar y Archivar de la card:
            if (finishReasonByPosting.reason === 'leave_credit') {
              sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Publicar aviso');
              if (lockedSoft) return openModal(e, 'lockedSoft');
              return openModal(e, 'activationModal');
            }
            sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Archivar Dropdown');
            return openModal(e, 'archiveModal');
          }}
        >
          {t(
            `panel.avisos.finishReason.cta.${finishReasonByPosting.reason === 'leave_credit' ? 'republish' : 'archive'}`
          )}
        </ButtonCTA>
      ) : null}
    </Container>
  );
};

export default FinishReasonInfo;

const Container = styled.div`
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
`;

const Title = styled.div`
  color: ${select('negative')};
  margin-top: 10px;
`;

const TextReason = styled.p`
  width: 350px;
  color: ${select('grayDarkLight')};
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`;

const ButtonCTA = styled.button`
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 20px;
  cursor: pointer;
`;
